/* LIVA interactions. Reuses Mojave's <product-form> and <cart-drawer>; no dependencies. */
(() => {
  const fmt = (c) => {
    const w = Math.floor(c / 100), k = c % 100;
    return w.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (k ? ',' + String(k).padStart(2, '0') : '') + ' TL';
  };
  const shake = (el) => { el.classList.remove('bv-opt--shake'); void el.offsetWidth; el.classList.add('bv-opt--shake'); };

  /* ---------- Video player (shared) ---------- */
  let player;
  const openPlayer = (src, cap, url) => {
    if (!player) {
      player = document.createElement('div');
      player.className = 'bv bv-player';
      player.setAttribute('role', 'dialog');
      player.setAttribute('aria-modal', 'true');
      player.setAttribute('aria-label', 'Ürün videosu');
      player.innerHTML = '<div class="bv-player__bar"><span data-cap></span><button type="button" class="bv-player__close" aria-label="Kapat">×</button></div><video playsinline muted loop controls preload="auto"></video><a class="bv-btn bv-player__shop" data-shop hidden>Ürünü gör</a>';
      document.body.appendChild(player);
      const close = () => { player.classList.remove('is-open'); player.querySelector('video').pause(); document.documentElement.style.overflow = ''; player._opener && player._opener.focus(); };
      player.querySelector('.bv-player__close').addEventListener('click', close);
      player.addEventListener('click', (e) => { if (e.target === player) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && player.classList.contains('is-open')) close(); });
    }
    const v = player.querySelector('video');
    player.querySelector('[data-cap]').textContent = cap || '';
    const shop = player.querySelector('[data-shop]');
    if (url && url !== location.pathname) { shop.href = url; shop.hidden = false; } else { shop.hidden = true; }
    player._opener = document.activeElement;
    v.src = src;
    player.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    v.play().catch(() => {});
    player.querySelector('.bv-player__close').focus();
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bv-play]');
    if (b) { e.preventDefault(); openPlayer(b.dataset.bvPlay, b.dataset.bvCap, b.dataset.bvUrl); }
    const o = e.target.closest('[data-bv-open]');
    if (o) { const d = document.getElementById(o.dataset.bvOpen); d && d.showModal && d.showModal(); }
    const c = e.target.closest('[data-bv-close]');
    if (c) { const d = c.closest('dialog'); d && d.close(); }
    const dlg = e.target.tagName === 'DIALOG' ? e.target : null;
    if (dlg && dlg.classList.contains('bv-dialog')) dlg.close();
  });

  /* ---------- Product page ---------- */
  const initPdp = (root) => {
    const data = JSON.parse(root.querySelector('[data-bv-product]').textContent);
    const form = root.querySelector('product-form form');
    const pf = root.querySelector('product-form');
    const idInput = root.querySelector('[data-bv-variant]');
    const atc = root.querySelector('[data-bv-atc]');
    const atcLabel = root.querySelector('[data-bv-atc-label]');
    const err = root.querySelector('[data-bv-error]');
    const track = root.querySelector('[data-bv-track]');
    const counter = root.querySelector('[data-bv-count]');
    const sticky = root.querySelector('[data-bv-sticky]');
    const stickySel = root.querySelector('[data-bv-sticky-sel]');
    const sets = [...root.querySelectorAll('[data-bv-option]')];
    const sizeFs = root.querySelector('[data-bv-size-fieldset]');

    const selected = () => sets.map((fs) => { const r = fs.querySelector('input:checked'); return r ? r.value : null; });
    const findVariant = (sel) => data.variants.find((v) => v.options.every((o, i) => o === sel[i]));

    const update = (fromColor) => {
      const sel = selected();
      sets.forEach((fs, i) => {
        const r = fs.querySelector('input:checked');
        const lab = fs.querySelector('[data-bv-selected]');
        if (lab) lab.textContent = r ? fs.querySelector(`label[for="${r.id}"]`).textContent.trim() : 'Seçilmedi';
      });
      // grey out sizes that are unavailable in the chosen colour
      if (data.sizeIndex !== null && sizeFs) {
        sizeFs.querySelectorAll('input').forEach((inp) => {
          const probe = sel.slice(); probe[data.sizeIndex] = inp.value;
          const v = findVariant(probe);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      }
      const complete = sel.every((s) => s !== null);
      const probe = sel.map((s, i) => s === null ? (data.variants[0].options[i]) : s);
      const variant = findVariant(complete ? sel : probe) || data.variants.find((v) => data.colorIndex !== null && v.options[data.colorIndex] === sel[data.colorIndex]);
      if (!variant) return;
      root.querySelectorAll('[data-bv-price]').forEach((p) => { p.textContent = fmt(variant.price); });
      if (complete) {
        idInput.value = variant.id;
        const u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u);
        atc.disabled = !variant.available;
        atcLabel.textContent = variant.available ? 'Sepete ekle · ' + fmt(variant.price) : 'Bu beden tükendi';
        if (stickySel) stickySel.textContent = sets.map((fs) => { const r = fs.querySelector('input:checked'); return fs.querySelector(`label[for="${r.id}"]`).textContent.trim(); }).join(' · ');
        err.textContent = '';
      }
      if (!complete) atcLabel.textContent = 'Beden seç';
      if (fromColor && variant.media && track) {
        const target = track.querySelector(`[data-media-id="${variant.media}"]`);
        if (target) target.classList.remove('bv-gallery__item--more');
        if (target && target !== track.firstElementChild) {
          // Bring the chosen colour's photo to the front (works for the mobile swipe track and the desktop grid).
          track.prepend(target);
          const img = target.querySelector('img');
          if (img) { img.loading = 'eager'; }
        }
        track.scrollTo({ left: 0, behavior: 'smooth' });
      }
    };
    sets.forEach((fs, i) => fs.addEventListener('change', () => update(i === data.colorIndex)));

    // Block submit until every option (size) is chosen — capture phase runs before Mojave's handler.
    pf.addEventListener('submit', (e) => {
      if (selected().some((s) => s === null)) {
        e.preventDefault(); e.stopImmediatePropagation();
        err.textContent = 'Önce bedenini seç.';
        if (sizeFs) { shake(sizeFs); sizeFs.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      }
    }, true);

    const more = root.querySelector('[data-bv-more]');
    if (more && track) more.addEventListener('click', () => { track.classList.add('is-all'); });

    if (track && counter) {
      const items = [...track.children];
      const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) counter.textContent = items.indexOf(en.target) + 1; }), { root: track, threshold: 0.6 });
      items.forEach((it) => io.observe(it));
    }

    if (sticky && atc) {
      // Keep the sticky button honest: mirror the main add-to-cart state (sold out stays sold out).
      const stickyBtn = sticky.querySelector('[data-bv-sticky-btn]');
      const syncSticky = () => {
        const sold = atc.disabled || atc.getAttribute('aria-disabled') === 'true';
        stickyBtn.disabled = sold;
        stickyBtn.textContent = sold ? (atc.textContent.trim() || 'Tükendi') : 'Sepete ekle';
      };
      syncSticky();
      new MutationObserver(syncSticky).observe(atc, { attributes: true, childList: true, subtree: true, characterData: true });
      const io2 = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && !document.querySelector('.bv-player.is-open');
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      });
      io2.observe(atc);
      sticky.querySelector('[data-bv-sticky-btn]').addEventListener('click', () => {
        if (selected().some((s) => s === null)) {
          sizeFs.scrollIntoView({ block: 'center', behavior: 'smooth' });
          setTimeout(() => shake(sizeFs), 350);
          err.textContent = 'Önce bedenini seç.';
          return;
        }
        form.requestSubmit ? form.requestSubmit(atc) : atc.click();
      });
    }
    update(false);
  };

  /* ---------- Takımını kur (Tam Görünüm): renk → iki beden → üçüncü parça → özet → sepete ekle; tek istek ---------- */
  const store = {
    get: (k) => { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  const initSet = (root) => {
    const data = JSON.parse(root.querySelector('[data-bv-set-data]').textContent);
    const $ = (s) => root.querySelector(s);
    const form = $('[data-bv-set-form]'), msg = $('[data-bv-set-msg]'), btn = $('[data-bv-set-btn]'), sum = $('[data-bv-sum]');
    const ara = $('[data-bv-ara]'), ind = $('[data-bv-ind]'), indAd = $('[data-bv-ind-ad]'), indT = $('[data-bv-ind-tutar]'), dip = $('[data-bv-dipnot]');
    const totals = ['[data-bv-total]', '[data-bv-total-btn]', '[data-bv-total-cubuk]'].map((s) => $(s)).filter(Boolean);
    const lev3 = $('[data-bv-levha3]'), lev3Img = $('[data-bv-levha3-img]'), lev3Ad = $('[data-bv-levha3-ad]');
    const skey = 'bv-look-' + root.dataset.sectionId;
    const val = (n) => { const r = form.querySelector(`input[name="${n}"]:checked`); return r ? r.value : null; };
    const lineOf = (p) => root.querySelector(`[data-bv-part="${p.key}"]`);
    const isOn = (p) => p.core || !!(lineOf(p).querySelector('[data-bv-addon]') || {}).checked;
    const colorOf = (p) => p.colorIndex === null ? null : (p.core ? val('bvs-color') : val(`bvs-${p.key}-${p.colorIndex}`));
    const sizeOf = (p) => p.sizeIndex === null ? null : val(`bvs-${p.key}-${p.sizeIndex}`);
    const variantOf = (p, size) => p.variants.find((v) => (p.colorIndex === null || v.options[p.colorIndex] === colorOf(p)) && (p.sizeIndex === null || v.options[p.sizeIndex] === (size || sizeOf(p))));
    const anyOf = (p) => p.variants.find((v) => p.colorIndex === null || v.options[p.colorIndex] === colorOf(p)) || p.variants[0];
    // "hazır" = sepete gidecek varyant tam seçili (dahil edilmiş ama bedeni seçilmemiş parça hazır sayılmaz)
    const ready = (p) => isOn(p) && (p.sizeIndex === null || !!sizeOf(p)) && (p.colorIndex === null || !!colorOf(p));
    const colorName = (p) => p.colorIndex === null ? '' : (p.colors[colorOf(p)] || colorOf(p) || '');
    const desc = (p) => [colorName(p), p.sizeIndex === null ? '' : (sizeOf(p) ? sizeOf(p) + ' beden' : 'beden seçilmedi')].filter(Boolean).join(' · ');
    const doby = $('[data-bv-set-doby]');
    let lastReady = 0;

    const render = () => {
      const on = data.parts.filter(isOn), extras = on.filter((p) => !p.core);
      const cores = data.parts.filter((p) => p.core), missing = on.filter((p) => !ready(p));
      const nReady = on.filter(ready).length;
      // sizes sold out in the chosen colour
      data.parts.forEach((p) => {
        const line = lineOf(p); line.classList.toggle('is-on', isOn(p)); line.classList.toggle('is-hazir', ready(p));
        if (p.sizeIndex !== null) line.querySelectorAll(`input[name="bvs-${p.key}-${p.sizeIndex}"]`).forEach((inp) => {
          const v = variantOf(p, inp.value); inp.classList.toggle('is-unavailable', !v || !v.available);
        });
        const shown = variantOf(p) || anyOf(p);
        const img = line.querySelector('[data-bv-part-img]'); if (img && shown.img && img.getAttribute('src') !== shown.img) img.src = shown.img;
        const pr = line.querySelector('[data-bv-part-price]'); if (pr) pr.textContent = fmt(shown.price);
      });
      // plates
      cores.forEach((p, i) => { const d = root.querySelector(`[data-bv-levha-durum="p${i + 1}"]`); if (d) d.textContent = desc(p); });
      if (lev3) {
        const x = extras[0];
        lev3.classList.toggle('is-bos', !x);
        if (x) {
          const v = variantOf(x) || anyOf(x);
          if (v.big && lev3Img.getAttribute('src') !== v.big) { lev3Img.loading = 'eager'; lev3Img.src = v.big; }
          lev3Img.alt = `${x.name}, ${colorName(x).toLowerCase()}, gerçek ürün fotoğrafı`; lev3Img.hidden = false;
          lev3Ad.textContent = extras.map((e) => e.short).join(' + ');
          root.querySelector('[data-bv-levha-durum="p3x"]').textContent = extras.length > 1 ? `${extras.length} parça` : desc(x);
        } else {
          lev3Img.hidden = true; lev3Ad.textContent = 'Üçüncü parça'; root.querySelector('[data-bv-levha-durum="p3x"]').textContent = 'Seçilmedi';
        }
      }
      // progress: pieces count as ready only when their variant is fully chosen
      const pips = [...root.querySelectorAll('[data-bv-pip]')];
      const st = [cores[0], cores[1]].map((p) => ready(p) ? 'hazir' : 'dahil').concat([extras.length ? (extras.every(ready) ? 'hazir' : 'dahil') : 'bos']);
      pips.forEach((pi, k) => { pi.className = st[k] ? 'is-' + st[k] : ''; });
      const t = $('[data-bv-prog-t]');
      let txt;
      if (!data.bxgy) txt = missing.length ? `${missing.map((p) => p.short).join(' ve ')} için beden seç.` : 'Seçimin hazır.';
      else if (cores.every((p) => !ready(p))) txt = '0 / 3 hazır · önce iki parçanın bedenini seç.';
      else if (cores.some((p) => !ready(p))) txt = `1 / 3 hazır · ${cores.find((p) => !ready(p)).short} için beden seç.`;
      else if (!extras.length) txt = '2 / 3 hazır · üçüncü parçayı seç.';
      else if (missing.length) txt = `2 / 3 hazır · ${missing[0].short} için beden seç.`;
      else txt = nReady === 3 ? '3 / 3 hazır · en düşük fiyatlı parça sepette ücretsiz.' : `${nReady} parça hazır · her üç parçada en düşük fiyatlı olan ücretsiz.`;
      if (t.textContent !== txt) t.textContent = txt;
      root.querySelector('[data-bv-prog]').classList.toggle('is-met', !missing.length && on.length >= 3);
      if (doby && window.BvDoby && nReady !== lastReady) window.BvDoby.playOn(doby, nReady >= 3 && lastReady < 3 ? 'tip' : 'tilt');
      lastReady = nReady;
      // summary from live variant prices; 3 AL, 2 ÖDE by the store rule (every group of three: lowest-priced piece free)
      const rows = [], priced = on.map((p) => ({ p, price: (variantOf(p) || anyOf(p)).price }));
      let sub = 0;
      priced.forEach(({ p, price }) => {
        sub += price;
        rows.push(`<div class="${ready(p) ? '' : 'is-eksik'}"><dt>${p.name}<small>${desc(p)}</small></dt><dd>${fmt(price)}</dd></div>`);
      });
      const sorted = priced.slice().sort((a, b) => a.price - b.price), k = data.bxgy ? Math.floor(priced.length / 3) : 0;
      const free = sorted.slice(0, k), off = free.reduce((a, b) => a + b.price, 0);
      sum.innerHTML = rows.join('');
      ara.textContent = fmt(sub);
      ind.hidden = !off; dip.hidden = !off;
      if (off) { indAd.textContent = `3 AL, 2 ÖDE · ücretsiz: ${free.map((f) => f.p.short).join(', ')}`; indT.textContent = '−' + fmt(off); }
      totals.forEach((el) => { el.textContent = fmt(sub - off); });
    };
    const save = () => {
      const s = { f: {} };
      form.querySelectorAll('input[type="radio"]:checked').forEach((i) => { s.f[i.name] = i.value; }); // add-ons are never pre-ticked on a new visit
      store.set(skey, s);
    };
    const setColor = (color) => {
      $('[data-bv-set-color-label]').textContent = data.labels[color] || color;
      root.querySelectorAll('[data-bv-stage]').forEach((im) => { const on = im.dataset.bvStage === color; if (on) { im.loading = 'eager'; im.hidden = false; } else im.hidden = true; });
    };
    const restore = () => {
      const s = store.get(skey); if (!s) return;
      Object.entries(s.f || {}).forEach(([n, v]) => { const el = form.querySelector(`input[name="${n}"][value="${CSS.escape(v)}"]`); if (el) el.checked = true; });
      form.querySelectorAll('input[type="radio"]:checked').forEach(label);
      setColor(val('bvs-color'));
    };
    const label = (inp) => {
      const lab = root.querySelector(`[data-bv-opt-label="${inp.name.replace('bvs-', '')}"]`);
      if (lab) lab.textContent = ((form.querySelector(`label[for="${inp.id}"]`) || {}).textContent || '').trim() || inp.value;
    };
    form.addEventListener('change', (e) => {
      const t = e.target;
      if (t.name === 'bvs-color') setColor(t.value);
      if (t.type === 'radio') label(t);
      if (t.matches('[data-bv-addon]') && t.checked) {
        const p = data.parts.find((x) => x.key === t.closest('[data-bv-part]').dataset.bvPart);
        if (p && p.sizeIndex !== null && !sizeOf(p)) { const fs = root.querySelector(`[data-bv-opt="${p.key}-${p.sizeIndex}"]`); if (fs) setTimeout(() => fs.scrollIntoView({ block: 'nearest', behavior: 'smooth' }), 60); }
      }
      msg.textContent = ''; msg.classList.remove('is-ok');
      render(); save();
    });
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const chosen = data.parts.filter(isOn), missing = chosen.filter((p) => p.sizeIndex !== null && !sizeOf(p));
      if (missing.length) {
        form.classList.add('is-denendi');
        msg.textContent = missing.length > 1 ? `${missing.map((p) => p.short).join(' ve ')} için beden seç.` : `${missing[0].name} için beden seç.`;
        missing.forEach((p) => { const fs = root.querySelector(`[data-bv-opt="${p.key}-${p.sizeIndex}"]`); if (fs) shake(fs); });
        const first = root.querySelector(`[data-bv-opt="${missing[0].key}-${missing[0].sizeIndex}"]`); if (first) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      const items = [];
      for (const p of chosen) {
        const v = variantOf(p);
        if (!v || !v.available) { msg.textContent = `${p.name}: bu renk ve beden şu an yok. Başka bir beden ya da renk seç.`; return; }
        items.push({ id: v.id, quantity: 1 });
      }
      btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true');
      const drawerEl = document.getElementById('cart-drawer'), drawer = document.querySelector('cart-drawer');
      try {
        const body = { items };
        if (drawerEl) { body.sections = drawerEl.dataset.id; body.sections_url = location.pathname; }
        const r = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const res = await r.json().catch(() => ({}));
        if (!r.ok || res.status) throw new Error(res.description || res.message || 'Sepete eklenemedi. Tekrar dene.');
        const cart = await (await fetch('/cart.js')).json();
        msg.classList.add('is-ok');
        msg.textContent = `${items.length} parça sepette. ` + (cart.total_discount > 0 ? `Shopify'ın sepette uyguladığı indirim: −${fmt(cart.total_discount)}. ` : 'Sepette indirim yok. ') + `Sepet toplamı ${fmt(cart.total_price)}.`;
        if (drawer && res.sections) drawer.renderContents(cart, res, '', '', false);
        else location.href = window.routes.cart_url;
      } catch (er) {
        msg.textContent = (er && er.message && !/fetch|network/i.test(er.message)) ? er.message : 'Bağlantı kurulamadı. İnternetini kontrol edip tekrar dene.';
      } finally { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    });
    // telefon: panel ekrandayken asıl düğme görünmüyorsa sabit çubuk
    const cubuk = $('[data-bv-cubuk]'), eylem = $('.liva-takim__eylem');
    if (cubuk && eylem && 'IntersectionObserver' in window) {
      const cbtn = cubuk.querySelector('[data-bv-cubuk-btn]'), dar = matchMedia('(max-width: 989px)');
      let panelIc = false, eylemIc = false;
      const guncelle = () => {
        const goster = dar.matches && panelIc && !eylemIc && !document.querySelector('cart-drawer.active, .bv-player.is-open');
        cubuk.classList.toggle('is-gorunur', goster); cubuk.setAttribute('aria-hidden', goster ? 'false' : 'true'); cbtn.tabIndex = goster ? 0 : -1;
      };
      new IntersectionObserver(([e]) => { panelIc = e.isIntersecting; guncelle(); }).observe(form);
      new IntersectionObserver(([e]) => { eylemIc = e.isIntersecting; guncelle(); }).observe(eylem);
      dar.addEventListener ? dar.addEventListener('change', guncelle) : dar.addListener(guncelle);
      document.addEventListener('cart:refresh', guncelle);
      cbtn.addEventListener('click', () => btn.click()); // aynı gönderim ve aynı ölçüm olayı
    }
    restore(); render();
  };

  /* ---------- Voices: editorial / verified reviews carousel + reader ---------- */
  const initVoices = (root) => {
    const track = root.querySelector('[data-bv-vtrack]');
    const prev = root.querySelector('[data-bv-vprev]'), next = root.querySelector('[data-bv-vnext]');
    const dlg = root.querySelector('dialog');
    const step = () => { const c = track.querySelector('.bv-vcard'); return c ? c.getBoundingClientRect().width + 20 : 300; };
    const sync = () => {
      if (!prev) return;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: smooth }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: smooth }));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: smooth }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: smooth }); }
    });
    sync();
    if (!dlg) return;
    root.querySelectorAll('[data-bv-vopen]').forEach((b) => b.addEventListener('click', () => {
      const tpl = root.querySelector(`#${b.dataset.bvVopen}`);
      dlg.querySelector('[data-bv-vbody]').innerHTML = tpl.innerHTML;
      dlg._opener = b; dlg.showModal();
    }));
    dlg.addEventListener('close', () => { dlg._opener && dlg._opener.focus(); });
    dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-bv-vclose]')) dlg.close(); });
  };

  /* ---------- Doby chips: the four real products. Plain toggles here so they work even if the Doby script is late or blocked;
     assets/bv-doby.js listens to the bv:dby-pick event to make Doby look at the chosen piece. ---------- */
  const initDobyChips = (box) => {
    if (box._bvChips) return; box._bvChips = true;
    const chips = [...box.querySelectorAll('[data-bv-dby-pick]')], cards = [...box.querySelectorAll('[data-bv-dby-card]')];
    const close = () => { chips.forEach((c) => c.setAttribute('aria-expanded', 'false')); cards.forEach((c) => { c.hidden = true; }); };
    const say = (open, i) => box.dispatchEvent(new CustomEvent('bv:dby-pick', { bubbles: true, detail: { open, i } }));
    chips.forEach((chip, i) => chip.addEventListener('click', () => {
      const open = chip.getAttribute('aria-expanded') === 'true'; close();
      if (!open) { chip.setAttribute('aria-expanded', 'true'); cards[i].hidden = false; }
      say(!open, i);
    }));
    box.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); say(false, -1); } });
  };

  const boot = () => {
    document.querySelectorAll('[data-bv-dby-explore]').forEach(initDobyChips);
    document.querySelectorAll('[data-bv-pdp]').forEach(initPdp);
    document.querySelectorAll('[data-bv-set]').forEach(initSet);
    document.querySelectorAll('[data-bv-voices]').forEach(initVoices);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-bv-dby-explore]').forEach(initDobyChips));
})();
